import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { type EchoNotesTimestamps } from '@/features/echonotes/echonotes-query';
import { formatTimestamp } from '@/utils/date';

interface EchoNotesTimestampSelectorProps {
  timestamps: EchoNotesTimestamps[];
  currentTimestampLabel: string;
  onTimestampSelect: (timestamp: EchoNotesTimestamps) => void;
}

export function EchoNotesTimestampSelector({
  timestamps,
  currentTimestampLabel,
  onTimestampSelect,
}: EchoNotesTimestampSelectorProps) {
  if (timestamps.length === 0) {
    return null;
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Icons.clock className="h-3 w-3" />
          {currentTimestampLabel}
          <Icons.chevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="max-h-[300px] overflow-y-auto">
        <DropdownMenu.Label>Latest included message</DropdownMenu.Label>
        {timestamps.map((ts) => (
          <DropdownMenu.Item key={ts.id} onClick={() => onTimestampSelect(ts)}>
            {formatTimestamp(ts.latest_included_message_timestamp)}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
